import { createContext } from 'react';
import { ModuleContext as TModuleContext } from './types';

export const ModuleContext = createContext<TModuleContext>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  null as any,
);
